import { environmentMapper, ENVIRONMENTS } from './environments';

export const getWrapperEnv = environmentMapper({
  'https://localhost.corp.adobe.com:8080': ENVIRONMENTS.local,
  'https://auth-light-sample.identity-stage.adobe.com': ENVIRONMENTS.stage,
  'https://auth-light-sample.identity-prestage.adobe.com':
    ENVIRONMENTS.prestage,
  'https://auth-light-sample.identity-preprod.adobe.com': ENVIRONMENTS.preprod,
});

// The iframe-side prestage/preprod CDN origins resolve to their own env: every
// byEnvironment map (urls.ts, analytics, logger) points prestage at STAGE and
// preprod at PROD APIs/analytics/logging, while keeping env-hosted URLs such as
// the popup helper, which must be same-site with the iframe (the wrapper's
// getPopupHelperOrigin expects the same host).
export const getAppEnv = environmentMapper({
  'https://localhost.corp.adobe.com:25000': ENVIRONMENTS.local,
  'https://auth-light.identity-stage.adobe.com': ENVIRONMENTS.stage,
  'https://auth-light.identity-prestage.adobe.com': ENVIRONMENTS.prestage,
  'https://auth-light.identity-preprod.adobe.com': ENVIRONMENTS.preprod,
});
